import $ from 'jquery';
import hcSticky from 'hc-sticky';
import { OverlayScrollbars } from 'overlayscrollbars';

$(document).ready(function () {
    const stickyShare = new hcSticky('.floating-social-links', {
        stickTo: document,
        top: $('#wpadminbar').length ? $('#wpadminbar').height() + 80 : 80,
    });

    new hcSticky('.hamburger', {
        stickTo: document,
        top: $('#wpadminbar').length ? $('#wpadminbar').height() + 60 : 60,
        responsive: {
            1365: {
                top: $('#wpadminbar').length
                    ? $('#wpadminbar').height() + 15
                    : 15,
            },
        },
    });

    window.addEventListener('resize', function () {
        stickyShare.update();
    });

    OverlayScrollbars(document.getElementById('slide-panel'), {
        className: 'os-theme-thin-dark',
    });
});

$('.hamburger, .panel-closer').on('click', () => {
    $('body').toggleClass('menu-active');
});
